import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@core/config/app.config.service';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HttpLoggerService {

    constructor(private readonly http: HttpClient,
        private readonly configService: ConfigService) { }

    sendLog(message: any): Observable<any> {
        return from(this.configService.getConfig()).pipe(
            switchMap(config => {
                const url = `${config.apiUrls.urlGatewayProcesos}/registros/logs`;
                return this.http.post(url, { ...message });
            })
        );
    }
}
